// extracted by mini-css-extract-plugin
module.exports = {"header":"Layout_header__9e3qX"};